import { useContext } from "react";
import { LoginStateContext } from "../context-providers/LoginStateProvider";

export const useLoginState = () => useContext(LoginStateContext);
